import {
  Flex,
  Heading,
  Link,
  Paragraph,
  Stack,
} from '@beamery/lib-ds-components';
import { SanitizedHtml } from 'design-system-extended';
import styled from 'styled-components';
import { useTranslation } from '../../../../hooks/use-translation';
import type { ComplianceProps } from './compliance.interface';
import { DataProtectionField } from './data-protection-field';

const Container = styled(Flex)`
  gap: ${({ theme }) => theme.space.x1};
  position: relative;
`;
Container.defaultProps = {
  direction: 'column',
};

const StyledSanitizedHtml = styled(SanitizedHtml)`
  & > :last-child {
    display: inline;
  }
`;

export const ComplianceV1 = ({
  fieldName,
  compliance,
  fieldValidationRules,
  control,
}: ComplianceProps) => {
  const { t } = useTranslation();

  if (
    compliance.consentQuestion === undefined ||
    compliance.consentRequestIntroductionStatement === undefined
  ) {
    return null;
  }

  return (
    <Container>
      <Heading variant='2'>
        {compliance.title ?? t('compliance.data-protection')}
      </Heading>
      <Stack gapBetweenChildren='x4'>
        <div>
          <SanitizedHtml>
            {compliance.consentRequestIntroductionStatement}
          </SanitizedHtml>

          <DataProtectionField
            control={control}
            fieldName={fieldName}
            fieldValidationRules={fieldValidationRules}
            label={
              <StyledSanitizedHtml>
                {compliance.consentQuestion}
              </StyledSanitizedHtml>
            }
          />
        </div>

        <Paragraph>
          <Link
            setting='inline'
            variant='emphasised'
            href={compliance.privacyPolicyUrl}
          >
            {compliance.privacyPolicyText || t('compliance.privacy-policy')}
          </Link>
        </Paragraph>
      </Stack>
    </Container>
  );
};
